import { render } from "./questionFour.vue?vue&type=template&id=dd38a54e"
import script from "./questionFour.vue?vue&type=script&lang=js"
export * from "./questionFour.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__